module.exports = __webpack_public_path__ + "static/media/bg-city.63a96abe.jpg";